import * as React from 'react';
import { observer } from 'mobx-react';

import { DefaultAppProps } from '../App';
import { ViewLayer } from '../managers/ViewManager';

import { LoadingTile as Base } from '@egr/xbox/progress-manager/LoadingTile';

export const LoadingTile: React.FC<DefaultAppProps> = observer(
    (props: DefaultAppProps) => {
        return (
            <Base modal={true} hide={props.app.viewManager.state.activeView === ViewLayer.Loading}/>
        );
    }
);
